<template>
  <div v-if="show" :class="['grid-item', className]" :style="className === 'grid-item-search' ? searchStyle : ''">
    <slot />
  </div>
</template>

<script>
/**
 * @description: 网格布局
 * 使用案例
 * 1. defaultSpan:4 适用于五个搜索条件，其中一个是时间区间搜索的情况
 * 2. defaultSpan1600:5,defaultSpan1500:3 适用于四个搜索条件，其中一个是时间区间搜索的情况
 * 3. defaultSpan1400:4 适用于两个搜索条件/六个搜索条件且时间区间搜索的情况
 * 4. defaultSpan1600:5,defaultSpan1400:4,defaultSpan1300:2 适用于三个搜索条件且有一个时间区间搜索的情况
 * 5. defaultSpan:4,defaultSpan1400:4 适用于6个搜索条件且有两个时间区间搜索的情况
 */
export default {
  props: {
    className: {
      type: String,
      // 可选的值 grid-item-common grid-item-date grid-item-search
      default: 'grid-item-common',
    },
    show: {
      // 是否显示
      type: Boolean,
      default: true,
    },
    defaultSpan: {
      type: Number,
      default: 5,
    },
    defaultSpan1600: {
      type: Number,
      default: 4,
    },
    defaultSpan1500: {
      type: Number,
      default: 4,
    },
    defaultSpan1400: {
      type: Number,
      default: 3,
    },
    defaultSpan1300: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      searchStyle: {
        gridColumn: `${this.defaultSpan} / span 1`,
      },
    }
  },
  mounted() {
    this.resize()
    // 监听屏幕变化
    window.addEventListener('resize', e => {
      this.resize(e)
    })
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', e => {
      this.resize(e)
    })
  },
  methods: {
    // 监听屏幕变化
    resize(e) {
      let width = e ? e.target.innerWidth : window.innerWidth
      switch (!!width) {
        case width < 1000:
          this.searchStyle = {
            gridColumn: `1 / span 1`,
          }
          break
        case width >= 1000 && width < 1300:
          this.searchStyle = {
            gridColumn: `${this.defaultSpan1300} / span 1`,
          }
          break
        case width >= 1300 && width < 1400:
          this.searchStyle = {
            gridColumn: `${this.defaultSpan1400} / span 1`,
          }
          break

        case width >= 1400 && width < 1500:
          this.searchStyle = {
            gridColumn: `${this.defaultSpan1500} / span 1`,
          }
          break
        case width >= 1500 && width < 1600:
          this.searchStyle = {
            gridColumn: `${this.defaultSpan1600} / span 1`,
          }
          break
        case width >= 1600:
          this.searchStyle = {
            gridColumn: `${this.defaultSpan} / span 1`,
          }
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.grid-item-common {
  grid-column: span 1 / span 1;
  -ms-grid-column: span 1 / span 1;
  margin-left: unset;
}
.grid-item-date {
  grid-column: span 2 / span 2;
  /* IE repeat syntax */
  -ms-grid-column: span 2 / span 2;
  margin-left: unset;
  display: grid;
  grid-template-columns: auto 20px auto;
  /* IE repeat syntax */
  display: -ms-grid;
  -ms-grid-columns: auto 20px auto;
  .separate {
    text-align: center;
    line-height: 33px;
  }
}
.grid-item {
  ::v-deep .el-form-item {
    display: flex;

    margin-right: 0 !important;
  }
  ::v-deep .el-form-item__content {
    flex: 1;
  }
}
.grid-item-search {
  /* IE repeat syntax */
  -ms-grid-column: 5 / span 1;
  margin-left: unset;
  ::v-deep .el-form-item__content {
    display: flex;
    justify-content: flex-end;
  }
}
::v-deep .el-form-item__label {
  flex-shrink: 0 !important;
}
::v-deep .el-select {
  width: 100% !important;
}
::v-deep .el-date-editor {
  width: 100% !important;
}
::v-deep .el-input__inner {
  width: 100% !important;
}
</style>
